import { render, staticRenderFns } from "./maintenanceSettlement.vue?vue&type=template&id=23489c03"
import script from "./maintenanceSettlement.vue?vue&type=script&lang=js"
export * from "./maintenanceSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports